export type HabitDisplaySortInput = {
  target: number | null;
  total: number;
  displayOrder: number;
};

export type HabitActivityTypeSortSource = {
  id: string;
  kind: string;
  displayOrder: number;
};

export type HabitDaySortSource = {
  activityTypeId: string;
  total: number;
  target: number | null;
  openTaskCount?: number;
};

export type HabitDisplaySortRow = HabitDisplaySortInput & {
  activityTypeId: string;
  openTaskCount: number;
};

export function isHabitGoalMet(habit: Pick<HabitDisplaySortInput, 'target' | 'total'>): boolean {
  return habit.target !== null && habit.total >= habit.target;
}

export function compareHabitsForDisplay(
  left: HabitDisplaySortInput,
  right: HabitDisplaySortInput
): number {
  return left.displayOrder - right.displayOrder;
}

export function habitDisplaySortRows(
  activityTypes: ReadonlyArray<HabitActivityTypeSortSource>,
  dayHabits: ReadonlyArray<HabitDaySortSource> | undefined
): HabitDisplaySortRow[] {
  return activityTypes
    .filter((activity) => activity.kind === 'HABIT_COUNTER')
    .map((activity) => {
      const existingHabit = dayHabits?.find((habit) => habit.activityTypeId === activity.id);
      return {
        activityTypeId: activity.id,
        total: existingHabit?.total ?? 0,
        target: existingHabit?.target ?? null,
        openTaskCount: existingHabit?.openTaskCount ?? 0,
        displayOrder: activity.displayOrder
      };
    })
    .sort(compareHabitsForDisplay);
}

export function orderedHabitActivityTypeIds(
  activityTypes: ReadonlyArray<HabitActivityTypeSortSource>,
  dayHabits: ReadonlyArray<HabitDaySortSource> | undefined
): string[] {
  return habitDisplaySortRows(activityTypes, dayHabits).map((row) => row.activityTypeId);
}

export function nextIdAfter(currentId: string, orderedIds: readonly string[]): string | null {
  const currentIndex = orderedIds.indexOf(currentId);
  if (currentIndex < 0 || currentIndex >= orderedIds.length - 1) {
    return null;
  }
  return orderedIds[currentIndex + 1];
}
